import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sales-channel q-mb-md"
}
const _hoisted_2 = {
  key: 1,
  class: "q-mb-md"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "right" }
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["ChannelServiceLink"], {
      catalogue: $props.supplierCatalogue,
      "onUpdate:catalogue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('update:catalogue', _ctx.catalogue?.sys?.id, $event))),
      modelValue: $setup.showServiceModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.showServiceModal) = $event))
    }, null, 8, ["catalogue", "modelValue"]),
    (!$props.supplierCatalogue?.service?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_btn, {
            class: "q-mb-none",
            unelevated: "",
            rounded: "",
            color: "primary",
            size: "sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showServiceModal = true)),
            disable: _ctx.readonly
          }, {
            default: _withCtx(() => [
              _createVNode($setup["AddIcon"], { left: "" }),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Connect an app", -1))
            ]),
            _: 1
          }, 8, ["disable"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["EditableBlock"], {
            title: "Sync settings",
            layout: "grid",
            "model-value": $props.supplierCatalogue,
            "column-count": 1,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:supplier-catalogue', $props.supplierCatalogue?.sys?.id, $event)))
          }, {
            default: _withCtx(({ editState, editingRef, save }) => [
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "description q-mb-md" }, [
                  _createElementVNode("span", null, "Link this channel to an external app &"),
                  _createElementVNode("br"),
                  _createElementVNode("span", null, "choose what data will be synced")
                ], -1)),
                _createVNode($setup["EditableBlockInput"], {
                  label: editState.service?.id ? 'Linked to' : editingRef?.value ? 'Link To' : 'Not linked to an external app',
                  "model-value": editState.service?.id,
                  "onUpdate:modelValue": ($event: any) => ($setup.updateService(editState, $event))
                }, {
                  static: _withCtx(({ inputState }) => [
                    _createElementVNode("span", null, _toDisplayString($setup.serviceOptions?.find(so => so.value === inputState.value)?.label || inputState.value), 1)
                  ]),
                  input: _withCtx(({ inputState }) => [
                    _createVNode(_component_form_select, {
                      "model-value": $setup.serviceOptions?.find(so => so.value === inputState.value),
                      onSelect: e => e.value === true ? $setup.createNewService() : inputState.value = e.value,
                      type: "select",
                      label: inputState.label,
                      placeholder: "Choose a service",
                      options: $setup.serviceOptions.concat({ label: '+ Link to new App', value: true })
                    }, null, 8, ["model-value", "onSelect", "label", "options"])
                  ]),
                  _: 2
                }, 1032, ["label", "model-value", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["sync-switches", { 'disable-switches': !editState.service?.id }]),
                  onClick: _withModifiers(() => $setup.onSyncSwitchesClick(editState, editingRef), ["stop"])
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sync-label" }, "Orders", -1)),
                  _createVNode($setup["MultiSwitch"], {
                    "model-value": editState.service?.sync?.source_order?.active || 0,
                    "onUpdate:modelValue": ($event: any) => ($setup.setSync(editState, editingRef, 'source_order', $event)),
                    options: $setup.syncSwitchOptions
                  }, null, 8, ["model-value", "onUpdate:modelValue"]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sync-label" }, "Stock Items", -1)),
                  _createVNode($setup["MultiSwitch"], {
                    "model-value": editState.service?.sync?.stock_item?.active || 0,
                    "onUpdate:modelValue": ($event: any) => ($setup.setSync(editState, editingRef, 'stock_item', $event)),
                    options: $setup.syncSwitchOptions,
                    disable: ['push','both']
                  }, null, 8, ["model-value", "onUpdate:modelValue"]),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sync-label" }, "Inventory", -1)),
                  _createVNode($setup["MultiSwitch"], {
                    "model-value": editState.service?.sync?.inventory?.active || 0,
                    "onUpdate:modelValue": ($event: any) => ($setup.setSync(editState, editingRef, 'inventory', $event)),
                    options: $setup.syncSwitchOptions,
                    disable: ['pull','push','both'],
                    readonly: ""
                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                ], 10, _hoisted_5)
              ]),
              _withDirectives(_createVNode(_component_ozn_button, {
                class: "minimal",
                label: "Sync options",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showServiceConfig = true))
              }, null, 512), [
                [_vShow, editState.service?.id]
              ]),
              _createVNode(_component_q_dialog, {
                modelValue: $setup.showServiceConfig,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.showServiceConfig) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card, { style: {"min-width":"70vw","padding":"2.8rem"} }, {
                    default: _withCtx(() => [
                      _createVNode($setup["EventConfigEditor"], {
                        modelValue: editState.service,
                        "onUpdate:modelValue": ($event: any) => ((editState.service) = $event),
                        onSave: save,
                        title: "Sync options",
                        types: ["source_order","stock_item"]
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onSave"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ]),
            _: 1
          }, 8, ["model-value"])
        ]))
  ], 64))
}